import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="EngagementHQ" link="https://www.bangthetable.com/engagementhq-community-software" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Build stronger communities through meaningful engagement. The EngagementHQ software empowers your community to easily and securely participate online.
    </ProjectCard>
    <ProjectCard title="Eventackle" link="https://www.eventackle.com/" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
Eventackle offers a free business event platform to explore and promote conferences, exhibitions and virtual events. Create event pages with us and sell tickets.
    </ProjectCard>
    <ProjectCard title="Lingva" link="https://play.google.com/store/apps/details?id=com.graphicweavee.lingva&hl=en" bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)" mdxType="ProjectCard">
The Lingva App is for parents and teachers of the Lingva Language School. This app allows teachers and parents to communicate about the activities and performance of the students.
    </ProjectCard>
    <ProjectCard title="Pycoin" link="https://github.com/aquibyatoo/pycoin" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
Pycoin is a Cryptocurrency app based on blockchain concept. Technologies I have used in this application  are python, flask and vue.js and am really looking forward to ship this soon.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      